import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import { Table, Card, Row, Spin, Col } from 'antd';
import getImzacilarListByDosyaKodu from "../../services/getImzacilarListByDosyaKodu";
import { errorMessage } from "../Helpers/Util";

const parsed = queryString.parse(history.location.search);

const ImzacilariListeleForm = () => {
  const [spining, setSpining] = useState(false);
  const [imzacilarList, setImzacilarList] = useState([]);
  const dosyaKodu = parseInt(parsed.dosyaKodu);

  const load = async () => {
    setSpining(true);
    await getImzacilarListByDosyaKodu(dosyaKodu).then(res => {
      if (res.data.success) {
        setImzacilarList(res.data.result);
      } else {
        errorMessage(res.data.message)
      }
    }).catch(err => {
      errorMessage(err.message)
    });
    setSpining(false);
  }
  useEffect(() => {
    load()
  }, []);

  // "dosyaKodu": 656863,
  // "Adsoyad": MEHMET EROĞLU,
  // "Tckn": 33664733588,

  const columns = [
    {
      title: 'Ad-Soyad',
      dataIndex: 'Adsoyad',
      width: '30%',
      editable: true,
    },
    {
      title: 'Tckn',
      dataIndex: 'Tckn',
      width: '30%',
      editable: true,
    },
    {
      title: 'Kullanıcı Grupları',
      dataIndex: 'GrupAciklamaList',
      width: '40%',
      editable: true,
      render: (text, record) => {
        return (
          <ul>
            {record.GrupAciklamaList && record.GrupAciklamaList.map((item, index) => (
              item != null && item !== '' && (
                <li key={index}>{item}</li>
              )
            ))}
          </ul>
        );
      }
    }

  ];

  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} >
    <Card
      style={{ margin: "20px" }}
      title={<h4 style={{ fontWeight: "bolder", color: "white" }}>İmzalayanlar Listesi</h4>}
      className="ant-card-head-title-large">
      <Row gutter={16}>
        <Col span={24}>
          {imzacilarList.length > 0 &&
            <Table scroll={{}} pagination={false} rowKey={"Tckn"} bordered dataSource={imzacilarList}
              columns={columns}
              title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3>
              </div>}
            />
          }
        </Col>
      </Row>
    </Card>
  </Spin>

}
export default ImzacilariListeleForm;